export default "__VITE_ASSET__CCJzqhj7__"